/* eslint-disable */

import * as XLSX from 'xlsx'
import { StyleSheet } from 'aphrodite'
import React, { useState } from 'react'
import { TECH_CATEGORY_LIST, TECH_LIST } from "../../urls";
import { useLoad } from "../../hooks/request";
import { useQueryParams } from "../../hooks/queryString";
import DateFilter from "../../components/common/DateFilter";
import Button from "../../components/common/Button";
import { useModal } from "../../hooks/modal";
import Table from "../../components/common/Table";
import Layout from "../../components/Layout";
import TechItem from "./TechItem";
import TechCreate from "./TechCreate";
import CustomFilterSelect from "../../components/common/CustomFilterSelect";
import Search from "../../components/Search";
import { isEmpty } from 'lodash'
import queryString from 'querystring'
import { useHistory } from 'react-router-dom'


export default function Tech() {
    const [page, setPage] = useState(1)
    const [params, setParams] = useState({})

    const searchParam = useQueryParams()
    const expense = useLoad(
        {
            url: TECH_LIST,
            params: { page, ...params, ...searchParam },
        },
        [searchParam, page, params],
    )
    const { response: subcategoryResponse } = useLoad({
        url: TECH_CATEGORY_LIST,
        params: { size: 1000 },
    })
    const subcategoryItems = subcategoryResponse ? subcategoryResponse.results : []
    const productList = expense.response ? expense.response.results : []
    const [showCreateModal, setShowCreateModal] = useModal(<TechCreate expenseReport={expense} onCancel={() => setShowCreateModal()} />, styles.modal)

    function format(value) {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
            useGrouping: true,
        })
            .format(value)
            .replace(/,/g, ' ')
    }

    console.log(productList[0])

    const exportToExcel = (response) => {
        const headers = [
            { text: 'ID', key: 'id' },
            { text: 'Статус', key: 'status' },
            { text: 'Категория', key: 'category' },
            { text: 'Масул Ходим', key: 'assigned' },
            { text: 'Сумма', key: 'amount' },
            { text: 'Изоҳ', key: 'comment' },
            { text: 'Сана', key: 'createdAt' },
        ]

        const data = response.results.map((item) => ({
            id: item.id,
            status: item.status === 'expenses' ? 'Чиқим' : 'Кирим',
            category: item.selectCategory?.name || '',
            subcategory: item.selectSubCategory?.name || '',
            assigned: item.selectAssigned?.username || '',
            amount: parseInt(item.amount, 10), // Ensure amount is an integer,
            comment: item.comment || '',
            createdAt: new Date(item.createdAt).toLocaleDateString('en-GB'),
        }))

        const totalRow = {
            id: '',
            status: '',
            category: '',
            assigned: 'ЖАМИ КИРИМ',
            amount: parseInt(response.totalIncomeAmount, 10),
            comment: '',
            createdAt: '',
        }
        const expensesRow = {
            id: '',
            status: '',
            category: '',
            assigned: 'ЖАМИ ЧИҚИМ',
            amount: parseInt(response.totalExpensesAmount, 10),
            comment: '',
            createdAt: '',
        }
        const balanceRow = {
            id: '',
            status: '',
            category: '',
            assigned: 'Баланс',
            amount: parseInt(response.balance, 10),
            comment: '',
            createdAt: '',
        }

        const rows = [headers.map((header) => header.text), ...data.map((item) => headers.map((header) => item[header.key])), ['', '', '', '', '', '', '', ''], Object.values(totalRow), Object.values(expensesRow), Object.values(balanceRow)]

        const ws = XLSX.utils.aoa_to_sheet(rows)

        // Apply border styles with 2px black borders
        const range = XLSX.utils.decode_range(ws['!ref'])
        const borderStyle = {
            top: { style: 'medium', color: { rgb: '000000' } },
            bottom: { style: 'medium', color: { rgb: '000000' } },
            left: { style: 'medium', color: { rgb: '000000' } },
            right: { style: 'medium', color: { rgb: '000000' } },
        }

        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cellAddress = XLSX.utils.encode_cell({ r: R, c: C })
                if (!ws[cellAddress]) ws[cellAddress] = { v: '' } // Create empty cells if needed
                ws[cellAddress].s = { border: borderStyle }
            }
        }

        // Set column widths
        const colWidths = headers.map((header, index) => {
            const maxLength = Math.max(...rows.map((row) => (row[index] ? row[index].toString().length : 0)))
            return { wch: maxLength + 2 }
        })
        ws['!cols'] = colWidths

        // Create workbook and append sheet
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Молия Маълумотлари')

        // Save to file
        XLSX.writeFile(wb, 'МолияМаълумотлари.xlsx')
    }
    const history = useHistory()

    function onSearch(query) {
        const search = !isEmpty(query) ? query : undefined
        history.push(`?${queryString.stringify({ ...searchParam, search })}`)
    }
    return (
        <Layout showCreateModal={showCreateModal}>
            <div className="">
                <div className="is-flex is-flex-direction-column">
                    <div className="level mb-4">
                        <div className="level-left">
                            <div className="level-item">
                                <Search onSearch={onSearch} />
                            </div>
                            <div className="level-item mr-2">
                                <DateFilter name="start_date" />
                            </div>
                            <div className="level-item">
                                <DateFilter name="end_date" />
                            </div>
                            <div className="level-item">
                                <CustomFilterSelect setSearchParams={setParams} placeholder="Категория" name="category" options={subcategoryItems} />
                            </div>
                        </div>

                        <div className="level-right">
                            <div className="level-item">
                                <Button text="Қўшиш" className="button is-link is-outlined" onClick={showCreateModal} />
                            </div>
                        </div>
                    </div>

                    <div className="columns is-mobile is-multiline">
                        <div className="column is-4-desktop is-12-mobile">
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#f0fff4',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <p className="has-text-success has-text-centered">
                                    <span className="icon-text">
                                        <ion-icon name="arrow-down-outline"></ion-icon>
                                        <b className="ml-2">Кирим:</b>
                                    </span>
                                    <span className="ml-2 has-text-weight-bold">{format(expense.response ? expense.response.totalIncomeAmount : 0)} Сум</span>
                                </p>
                            </div>
                        </div>

                        <div className="column is-4-desktop is-12-mobile">
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#fff5f5',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <p className="has-text-danger has-text-centered">
                                    <span className="icon-text">
                                        <ion-icon name="arrow-up-outline"></ion-icon>
                                        <b className="ml-2">Чиқим:</b>
                                    </span>
                                    <span className="ml-2 has-text-weight-bold">{format(expense.response ? expense.response?.totalExpensesAmount : 0)} Сум</span>
                                </p>
                            </div>
                        </div>

                        <div className="column is-4-desktop is-12-mobile">
                            <div
                                style={{
                                    padding: '15px',
                                    borderRadius: '8px',
                                    backgroundColor: '#f0f7ff',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                }}
                            >
                                <p className="has-text-info has-text-centered">
                                    <span className="icon-text">
                                        <ion-icon name="wallet-outline"></ion-icon>
                                        <b className="ml-2">Баланс:</b>
                                    </span>
                                    <span className="ml-2 has-text-weight-bold">{format(expense.response ? expense.response.balance : 0)} Сум</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-4 mb-4">
                <Table
                    loading={expense.loading}
                    items={productList}
                    columns={{
                        index: '№',
                        date: 'Сана',
                        subcategory: 'Масул Ходим',
                        status: 'Статус',
                        category: 'Категория',
                        amount: 'Сумма',
                        paymentType: 'Тўлов тури',
                        note: 'Эслатма',
                        buttons: '',
                    }}
                    totalCount={expense.response ? expense.response.count : 0}
                    activePage={page}
                    onPageChange={setPage}
                    renderItem={(item, index) => <TechItem expenseReport={expense} index={index} key={item.id} item={item} />}
                />
            </div>
        </Layout>
    )
}

const styles = StyleSheet.create({
    space: { marginTop: '2rem' },
    emptyImg: { width: '330px', height: '300px' },
    loader: { marginTop: '2rem' },
    modal: { width: 800 },
    checkmark: { marginRight: '3px' },
})
